/**
 * @author Milton Filho
 */

/**
 * The status the API answers when Clinicient already holds the slot.
 *
 * It used to be `500`, which reads as "try again" — and the queue obliged, on
 *   every reconnection. Named here because the meaning is what matters at both
 *   call sites: permanent refusal, not a transient failure.
 *
 * "Permanent" was a premise when this was written and is measured as of
 *   2026-09-08: across 60 days, 20 of 20 attempts made after a first refusal
 *   were refused too, the furthest 72.3 hours later, and no create follows a
 *   refusal for any `(case, app_datetime)`. See `syncOnReconnect$` for the rest
 *   of the grouping.
 *
 * The one thing that measurement does **not** establish is permanence beyond
 *   the observation window. A conflicting appointment can be cancelled — this
 *   app has `HOME_HEALTH_APPOINTMENT_CANCEL` and a cancellation screen — and a
 *   slot freed that way is bookable again. So "terminal" describes Clinicient's
 *   answer while the collision stands, not a fact about the slot for ever.
 */
export const BOOKING_CONFLICT_STATUS = 409;

/**
 * How long to wait for the schedule refetch that decides whether a conflicted
 * booking's optimistic card can be removed.
 *
 * On expiry the card stays. That is the safe direction: the `409` proved the
 *   slot is taken in Clinicient, and if we cannot confirm our own schedule
 *   knows it, leaving the slot looking occupied beats leaving it looking free.
 */
export const CONFLICT_REFETCH_TIMEOUT_MS = 15_000;
